import { watch } from "vue";

export default async function onLoad({ getters }) {
  return new Promise((resolve) => {
    if (getters.containerLoaded) {
      resolve();
    } else {
      watch(
        () => getters.containerLoaded,
        (loaded) => {
          if (loaded) {
            resolve();
          }
        },
      );
    }
  });
}
